import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';
import { brand } from 'src/themes/palette';
import { Theme } from '@mui/material/styles';

export const drawerWidth = 240;

// Keep your existing menu/subMenu (assumed already here)
export const menu = {
  paddingTop: GLOBAL_MARGIN_HORIZONTAL * 2,
  background: brand.drawerBackground,
  marginTop: '80px',
};
export const subMenu = {
  paddingBottom: GLOBAL_MARGIN_HORIZONTAL,
};

// AppBar
export const appBarSx = (theme: Theme) => ({
  backgroundColor: brand.white,
  zIndex: theme.zIndex.drawer + 1,
  height: 80,
});

// Drawer (desktop mini-variant)
export const desktopDrawerSx = (open: boolean) => ({
  width: open ? drawerWidth : 60,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: open ? drawerWidth : 60,
    overflowX: 'hidden',
    transition: 'width 0.3s',
    backgroundColor: brand.drawerBackground,
  },
});

// Drawer paper (mobile temporary)
export const mobileDrawerPaperSx = {
  width: drawerWidth,
  backgroundColor: brand.drawerBackground,
};

// Section header inside drawer
export const sectionHeaderSx = {
  px: 2,
  pb: 1,
  fontWeight: 'bold',
  color: brand.primary,
  fontSize: 12,
};

// ListItemIcon (centered icon when closed)
export const listItemIconSx = {
  minWidth: 0,
  justifyContent: 'center',
};

// ListItemButton alignment based on open/closed state (desktop)
export const listItemButtonSx = (open: boolean) => ({
  justifyContent: open ? 'flex-start' : 'center',
});

// Powered by text + link
export const poweredByCaptionSx = {
  mt: 1,
  textAlign: 'center',
  color: '#666',
};
export const poweredByLinkSx = {
  textDecoration: 'underline',
  cursor: 'pointer',
};

// Layout wrappers
export const rootBoxSx = { display: 'flex' };
export const mainSx = { flexGrow: 1 };
export const menuButtonSx = { marginRight: 2 };
